import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);
    try {
      const res = await fetch("http://localhost:5000/api/student-auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem("studentToken", data.token);
        localStorage.setItem("studentData", JSON.stringify(data.student));
        navigate("/student-dashboard");
      } else {
        setErrorMsg(data.message || "Login failed");
      }
    } catch (err) {
      setErrorMsg("Network error. Please try again later.");
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      {/* LEFT */}
      <div className="login-left">
        <div className="ll-inner">
          <div className="ll-badge">🔒 Secure Student Portal</div>
          <h1 className="ll-heading">
            Fees Management<br />
            <span className="ll-accent">System</span>
          </h1>
          <p className="ll-sub">
            Manage student fees, payments, reports and institution
            records with one powerful dashboard.
          </p>
          <div className="ll-stats">
            <div className="ll-stat"><h2>500+</h2><p>Institutions</p></div>
            <div className="ll-stat"><h2>50K+</h2><p>Students</p></div>
            <div className="ll-stat"><h2>99.9%</h2><p>Uptime</p></div>
          </div>
        </div>
      </div>

      {/* RIGHT */}
      <div className="login-right">
        <div className="login-card">
          <div className="lc-icon">👋</div>
          <h2 className="lc-title">Welcome Back</h2>
          <p className="lc-sub">Login to your student account</p>

          {errorMsg && <div className="lc-error"><span>⚠</span> {errorMsg}</div>}

          <form onSubmit={handleSubmit} className="lc-form">
            <div className="lc-field">
              <label>Email Address</label>
              <input type="email" placeholder="your@email.com"
                value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="lc-field">
              <label>Password</label>
              <input type="password" placeholder="Enter your password"
                value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <div className="lc-options">
              <label className="lc-remember"><input type="checkbox" /> Remember Me</label>
              <a href="/" className="lc-forgot">Forgot Password?</a>
            </div>
            <button type="submit" className="lc-btn" disabled={loading}>
              {loading ? <span className="lc-spinner" /> : "Login"}
            </button>
          </form>

          <p className="lc-signup-link">Don't have an account? <a href="/signup">Sign Up</a></p>
          <div className="lc-admin-link"><a href="/admin-login">🛡️ Admin Login</a></div>
        </div>
      </div>
    </div>
  );
}

export default Login;